import { jsx as _jsx } from "react/jsx-runtime";
const DIGIT_COUNT = 10;
const DIGITS = Array.from({ length: DIGIT_COUNT }, (_, index) => index);
const CHAR_WIDTH = {
    0: 33.02,
    1: 17.73,
    2: 29.59,
    3: 31.3,
    4: 30.69,
    5: 30.22,
    6: 31.15,
    7: 26.94,
    8: 31.57,
    9: 31.26,
};
const CHAR_WIDTH_SMALL = {
    0: 19.69,
    1: 10.58,
    2: 17.64,
    3: 18.66,
    4: 18.3,
    5: 18.02,
    6: 18.57,
    7: 16.06,
    8: 18.82,
    9: 18.63,
};
const AnimatedDigit = ({ value, small = false }) => {
    const parsedValue = parseInt(value);
    const yTranslation = -(parsedValue / DIGIT_COUNT) * 1000;
    return (_jsx("span", { className: "ui-animate-slide-in-down ui-overflow-hidden", children: _jsx("span", { className: "ui-flex ui-h-[1em] ui-flex-col ui-transition-[transform,width] ui-duration-500 ui-ease-in-out", style: {
                transform: `translateY(${yTranslation}%)`,
                width: `${small ? CHAR_WIDTH_SMALL[value] : CHAR_WIDTH[value]}px`,
            }, children: DIGITS.map((digit) => (_jsx("span", { children: digit }, digit))) }) }));
};
export default AnimatedDigit;
